// src/redux/proposalsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../actions/configApi'; // Ajuste o caminho conforme sua estrutura


export const fetchProposals = createAsyncThunk(
    'proposals/fetchProposals',
    async ({ page, searchTerm, sortDirection }, { rejectWithValue }) => {
        try {
            // Monte a URL com parâmetros de pesquisa e ordenação
            const response = await api.get(
                `proposals?page=${page}&search=${searchTerm}&sort=${sortDirection}`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

/**
 * Thunk para atualizar o status da proposta
 * e também disparar o envio de e-mail no servidor.
 */
export const updateProposalStatus = createAsyncThunk(
    'proposals/updateProposalStatus',
    async (payload, { rejectWithValue }) => {
        try {
            // Exemplo com Promise.allSettled ou Promise.all:
            const [emailResult, statusResult] = await Promise.all([
                api.post('/send-email', payload),
                api.post(`proposals/status/${payload.proposalId}`, payload),
            ]);

            // Se o servidor retorna a proposta atualizada em statusResult.data, retornamos:
            return statusResult.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const proposalsSlice = createSlice({
    name: 'proposals',
    initialState: {
        items: [],            // Listagem de propostas
        totalItems: 0,        // Total de registros no back-end
        currentPage: 1,       // Página atual
        itemsPerPage: 10,     // Por página (ajustar se necessário)
        loading: false,
        error: null,
        successMessage: null,
        // Filtro e ordenação
        searchTerm: '',
        sortDirection: 'desc',
        // Para focar no item atualizado
        updatedProposalId: null,
    },
    reducers: {
        // Ações simples para atualizar estado local
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
            state.currentPage = 1; // se quiser resetar para página 1 a cada busca
        },
        setSortDirection: (state, action) => {
            state.sortDirection = action.payload;
            state.currentPage = 1; // se quiser resetar para página 1 ao ordenar
        },
        clearUpdatedProposalId: (state) => {
            state.updatedProposalId = null;
        },
        clearMessages: (state) => {
            state.error = null;
            state.successMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchProposals.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProposals.fulfilled, (state, action) => {
                state.loading = false;
                // Estrutura esperada: { data: [...], total: 99 }
                state.items = action.payload.data;
                state.totalItems = action.payload.total;
            })
            .addCase(fetchProposals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            // Update
            .addCase(updateProposalStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(updateProposalStatus.fulfilled, (state, action) => {

                state.loading = false;
                state.successMessage = 'Status atualizado com sucesso!';
                // action.payload deve ser o objeto de proposta atualizado
                const { proposalId, status, codigo, rejectionReason, proposal_value_new, custo_frete, data_pagamento, codigo_dev } = action.payload;
                console.log(action.payload, 'action.payload')
                // Substitui na lista local
                const index = state.items.findIndex((p) => p.id === proposalId);
                if (index !== -1) {
                    // Mescla no item existente
                    state.items[index] = {
                        ...state.items[index],
                        status: status,
                        codigo: codigo,
                        rejectionReason: rejectionReason,
                        proposal_value_new: proposal_value_new,
                        custo_frete: custo_frete,
                        data_pagamento: data_pagamento,
                        codigo_dev: codigo_dev
                    };
                }
                state.updatedProposalId = proposalId;
            })
            .addCase(updateProposalStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export const {
    setCurrentPage,
    setSearchTerm,
    setSortDirection,
    clearUpdatedProposalId,
    clearMessages,
} = proposalsSlice.actions;

export default proposalsSlice.reducer;
